const INITIAL_STATE = {
  errors: {},
  addlead: {},
  updateLead: {},
  getLead: {},
  leadList: {}
}

const lead = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_LEAD_LIST_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, leadList: action.data }
  case 'GET_LEAD_LIST_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, addlead: action.data }
  case 'ADD_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, getLead: action.data }
  case 'GET_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'UPDATE_LEAD_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, updateLead: action.data }
  case 'UPDATE_LEAD_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  
  default:
    return { ...state }
  }
};

export default lead;
